<template lang="pug">
div
  el-row
    p.emptyHistorico(v-if="!historicos || historicos.length === 0") Não há dados.
    el-steps.steps(direction="vertical" :active="activeStep" v-else)
      el-step.step(
        v-for="(historico, index) in historicos",
        :key="historico.procInst"
        :title="getSetor(historico.codigoSetor) + ' - ' + historico.setor",
        @click.native="changeActive(index)",
        :class="{'inactive-step' : activeStep !== index, 'active-step' : activeStep === index}",
      )
        template(slot="icon")
          p.date-pad {{ getOnlyDate(historico.dataAcao) }}
            .circle
        template(slot="description" v-if="activeStep === index")
          .container-informacoes
            p.descricao(v-for="item in historico.descricaoAcoesSetorFormatado" ) {{ getDescricaoHistorico(item, historico) }}
</template>

<script>
import { mapActions } from 'vuex'
import AppPar from '@/components/AppPar'
import moment from 'moment'
const { setores } = require('@/utils/' + process.env.ESTADO + '/setor').default

export default {

  components: {
    AppPar
  },

  props: ['idProcesso'],

  data () {
    return {
      activeStep: 0,
      historicos: []
    }
  },

  async created () {
    this.historicos = await this.getHistorico(this.idProcesso)
    this.ordenarAcoesSetor()
    this.activeStep = this.historicos.length - 1
  },

  methods: {
    ...mapActions({
      getHistorico: 'processos/getHistorico'
    }),

    getDataDescricaoAcao (descricaoAcao) {
      return moment(descricaoAcao.substring(0, descricaoAcao.indexOf('-') - 1).trim(), 'DD/MM/YYY HH:mm:ss').toDate()
    },

    ordenarAcoesSetor () {
      this.historicos = this.historicos.map(historico => {
        if (historico.descricaoAcoesSetorFormatado) {
          historico.descricaoAcoesSetorFormatado = historico.descricaoAcoesSetorFormatado.sort((a, b) => this.getDataDescricaoAcao(a) - this.getDataDescricaoAcao(b))
        }
        return historico
      })
    },

    getOnlyDate (date) {
      return moment(date).format('DD/MM/YYYY')
    },

    changeActive (stepIndex) {
      this.activeStep = stepIndex
    },

    getDescricaoHistorico (item, historico) {
      return item.replace('$$', historico.setor.split(' ')[0])
    },

    getSetor (setor) {
      const setorEncontrado = Object.entries(setores).find(([_, value]) => setor.includes(value))
      return setorEncontrado && setorEncontrado.length ? setorEncontrado[1] : setor
    }

  }

}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.emptyHistorico {
  display: flex;
  justify-content: center;
}

.descricao {
  font-size: 13px;
}

.el-steps {
  p {
    margin: 0;
  }
  .el-step:hover {
    /deep/.el-step.is-vertical {
      .el-step__line {
        background-color: $color-primary;
        border-color: $color-primary;
      }
      .el-step__icon.is-text {
        border-color: $color-primary;
        color: $color-primary;
      }
      .el-step__icon-inner {
        color: $color-primary;
      }
      .el-step__title {
        color: $color-primary;
      }
    }

    .date-pad {
      color: $color-primary;
    }

    .circle {
      background: $color-primary;
    }
  }
}

/deep/ .el-step__icon.is-text {
  border: none;
  width: 100%;
}

/deep/ .el-step__title.is-process {
  color: $color-primary;
}

/deep/ .el-step__title.is-wait,
/deep/ .el-step__head.is-wait,
/deep/ .el-step__title.is-finish,
/deep/ .el-step__head.is-finish {
  color: black;
  border-color: black;
  opacity: 0.7;
}

/deep/ .el-step__head.is-wait,
/deep/ .el-step__head.is-finish {
  color: black;
  .el-step__line {
    background-color: black;
  }
}

/deep/ .el-step__head.is-process {
  color: $color-primary;
  font-weight: bold;
  .circle {
    background: $color-primary;
  }
  .el-step__line {
    background-color: $color-primary;
  }
  .el-step__icon.is-text {
    border-color: $color-primary;
  }
  .date-pad {
    color: $color-primary;
  }
}

/deep/ .el-step.is-vertical .el-step__line {
  left: 145px;
  margin-top: 5px;
}

/deep/ .el-step__description {
  margin-top: 10px !important;
  padding-left: 30px;
}

.inactive-step {
  flex-basis: 7% !important;
}

.active-step {
  flex-basis: unset !important;
}

/deep/ .el-step__head {
  cursor: pointer;
  width: 20% !important;
}

/deep/ .el-step__main {
  width: 80% !important;
  padding-left: 20px !important;
  padding-bottom: 10px;
  .el-step__title {
    cursor: pointer;
  }
}

.modal {
  height: 71vh;
}

.descricao {
  font-size: 13px;
}

.steps {
  padding: 20px;
}

.painel-historico {
  max-height: 65vh;
  overflow-y: auto;
}

.btn-baixar-pdf {
  float: right;
  padding: 13px 30px;
  font-size: 15px;
  margin-top: 15px;
  margin-right: 25px;
  margin-bottom: 15px;
}
.margin-left {
  margin-left: 5px;
}

.circle {
  border: black;
  border-radius: 50%;
  background: black;
  width: 16px;
  height: 16px;
}

.date-pad {
  padding-right: 25px;
  opacity: 0.6;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/modal/AppVisualizarHistoricoTramitacaoTab.vue